import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./chat-global.css"
import { User } from "../../global-components/src/types";
import { getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import { api } from "../../services/api";
import { useAuth, useTheme } from "../../global-components/src";
import EmojiPickerNative from "../../components/Textarea/Emojis/emoji-picker-native";
import { clearText } from "../../global-components/src/utils/text";
import ImgVerified from "../../components/imgVerified/ImgVerified";
import PermissionCheck from "../../components/PermissionCheck";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronsDown, Smile, Trash2 } from "lucide-react";
import { getNativeKeyboardHeight, getNativeNavigationHeight, isNewApp, isNewAppAndroid } from "../../utils/platform";
import { isIOSWebView } from "../../global-components/src/utils/platform";
import { fetchUsers } from "../../services/user";
import { debounce } from "lodash";
import { createEcho } from "../../hooks/useChatEcho";
import { isNearScrollBottom } from "../../utils/scroll-position";

type Message = {
  id: number | string;
  user: User
  text: string;
  pending?: boolean;
};

const ChatGlobal: React.FC = () => {
    const [open, setOpen] = useState(false);
    const [messages, setMessages] = useState<Message[] | null>(null);
    const { token, user } = useAuth();
    const { hideChatGlobal } = useTheme();
    const [text, setText] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalOnline, setTotalOnline] = useState(0);
    const [showEmoji, setShowEmoji] = useState(false);
    const chatRef = useRef<HTMLDivElement | null>(null);
    const messagesContentRef = useRef<HTMLDivElement | null>(null);
    const atBottomRef = useRef(true);
    const navigate = useNavigate();
    const location = useLocation();
    const [bottomPadding, setBottomPadding] = useState(10);
    const inputRef  = useRef<HTMLInputElement>(null);
    const [nativeKeyboardHeight, setNativeKeyboardHeight] = useState(getNativeNavigationHeight());
    const [showScrollToBottom, setShowScrollToBottom] = useState(false);

    // Mention autocomplete
    const [mentionSuggestions, setMentionSuggestions] = useState<any[]>([]);
    const [showMentions, setShowMentions] = useState(false);
    const [loadingMentions, setLoadingMentions] = useState(false);

    const debouncedFetchMentions = useMemo(
        () =>
            debounce(async (query: string) => {
                if (!query) { setMentionSuggestions([]); setLoadingMentions(false); return; }
                try {
                    const res = await fetchUsers(query, token);
                    setMentionSuggestions(res?.users ?? []);
                } catch {
                    setMentionSuggestions([]);
                } finally {
                    setLoadingMentions(false);
                }
            }, 500),
        [token]
    );

    const handleTextChange = (value: string) => {
        setText(value);

        const cursorIndex = inputRef.current?.selectionStart ?? value.length;
        const textBeforeCursor = value.slice(0, cursorIndex);
        const match = textBeforeCursor.match(/@([a-zA-Z0-9_]*)$/);

        if (match) {
            setShowMentions(true);
            setLoadingMentions(true);
            debouncedFetchMentions(match[1]);
        } else {
            setShowMentions(false);
            debouncedFetchMentions.cancel();
        }
    };

    const handleSelectMention = (userName: string) => {
        const cursorIndex = inputRef.current?.selectionStart ?? text.length;
        const before = text.slice(0, cursorIndex).replace(/@([a-zA-Z0-9_]*)$/, `@${userName} `);
        const after = text.slice(cursorIndex);
        const newText = before + after;
        setText(newText);
        setShowMentions(false);
        setMentionSuggestions([]);
        requestAnimationFrame(() => {
            inputRef.current?.focus();
            const pos = before.length;
            inputRef.current?.setSelectionRange(pos, pos);
        });
    };
    // useEffect(() => {
    //     const handleKeyboardHeightChange = () => {
    //         const heightKeyboard = getNativeKeyboardHeight();
    //         setHeightKeyboardGlobal(heightKeyboard)
    //         const nativeNavigationHeight = getNativeNavigationHeight() ?? 0;
    //         let height = 30;
    //         if (inputRef.current) height = inputRef?.current.clientHeight;

    //         setBottomPadding(heightKeyboard ? (heightKeyboard + nativeNavigationHeight + 10) : (nativeNavigationHeight + 10));
    //     };

    //     window.addEventListener("keyboardHeightChange", handleKeyboardHeightChange);

    //     return () => {
    //         window.removeEventListener("keyboardHeightChange", handleKeyboardHeightChange);
    //     };
    // }, []);

    
    // function ajustaNewApp() {
    //     if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
    //         const nativeNavigationHeight = getNativeNavigationHeight();
    //         let height = 30;
    //         if (inputRef.current) height = inputRef?.current.clientHeight;

    //         if(nativeNavigationHeight && nativeNavigationHeight > 0){
    //             setBottomPadding(nativeNavigationHeight + 10);
    //         }

    //         window.addEventListener("navigationBarHeightChange", ajustaNewApp);
    //         return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
    //     }
    // }
    // useEffect(() => {
    //     ajustaNewApp()
    // }, []);
    
    
    useEffect(() => {
        const handleKeyboardHeightChange = () => {
            const heightKeyboard = getNativeKeyboardHeight();
            const nativeNavigationHeight = getNativeNavigationHeight() ?? 0;

            setBottomPadding(heightKeyboard ? (heightKeyboard + nativeNavigationHeight + 10) : (nativeNavigationHeight + 10));
        };

        window.addEventListener("keyboardHeightChange", handleKeyboardHeightChange);

        return () => {
            window.removeEventListener("keyboardHeightChange", handleKeyboardHeightChange);
        };
    }, []);

    function ajustaNewApp() {
        if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
            const nativeNavigationHeight = getNativeNavigationHeight();
            const heightKeyboard = getNativeKeyboardHeight();

            if(nativeNavigationHeight && nativeNavigationHeight > 0){
                setBottomPadding(nativeNavigationHeight + (heightKeyboard ? 30 : 0));
            }

            window.addEventListener("navigationBarHeightChange", ajustaNewApp);
            return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
        }
    }
    useEffect(() => {
        ajustaNewApp()
    }, []);

    useEffect(() => {
        const onResize = () => {
            const visualViewport = window.visualViewport;
            const heightKeyboard = getNativeKeyboardHeight();
           

            if(!heightKeyboard) {
                ajustaNewApp();
            };

            if (!visualViewport) return;

            const offsetTop = visualViewport.offsetTop;
            const offsetBottom = window.innerHeight - visualViewport.height - offsetTop;

            if(heightKeyboard){
                setBottomPadding(prev => (prev !== offsetBottom ? (offsetBottom > 0 ? offsetBottom : 0) : prev));
            }
        };

        const viewport = window.visualViewport;
        viewport?.addEventListener("resize", onResize);
        viewport?.addEventListener("scroll", onResize);

        // Executa uma vez inicial
        onResize();

        return () => {
            viewport?.removeEventListener("resize", onResize);
            viewport?.removeEventListener("scroll", onResize);
        };
    }, []);

    useEffect(() => {
        scrollToBottom()
    }, [open]);

    useEffect(() => {
        const shouldScroll = isAtBottom();
        if(!shouldScroll) return;

        scrollToBottom()
    }, [messages?.length]);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    const loadMessages = async () => {
        const shouldScroll = isAtBottom();

        try {

            const res = await api(token).get("/chat-global");

            setMessages(res.data);

            if (shouldScroll) atBottomRef.current = true;

        } catch (error) {
            console.error("Erro ao carregar");
            console.error(error);

        }
    };

    const isAtBottom = () => {
        const element = chatRef.current;
        if (!element) return true;

        const atBottom = isNearScrollBottom(element);
        atBottomRef.current = atBottom;
        return atBottom;
    };

    const syncScrollToBottomVisibility = useCallback(() => {
        const element = chatRef.current;
        if (!element) return false;

        const atBottom = isNearScrollBottom(element);
        atBottomRef.current = atBottom;
        setShowScrollToBottom(current => {
            const next = !atBottom;
            return current === next ? current : next;
        });
        return atBottom;
    }, []);

    const scrollToBottom = (behavior: ScrollBehavior = 'smooth') => {
        const element = chatRef.current;
        if (!element) return;

        element.scrollTo({ top: element.scrollHeight, behavior });
    };

    useEffect(() => {
        const scroller = chatRef.current;
        const content = messagesContentRef.current;
        if (!open || !scroller || !content || typeof ResizeObserver === 'undefined') return;

        let frame = 0;
        const syncAfterLayout = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                if (atBottomRef.current) {
                    scroller.scrollTo({ top: scroller.scrollHeight, behavior: 'auto' });
                }
                syncScrollToBottomVisibility();
            });
        };
        const observer = new ResizeObserver(syncAfterLayout);
        observer.observe(scroller);
        observer.observe(content);
        syncAfterLayout();

        return () => {
            cancelAnimationFrame(frame);
            observer.disconnect();
        };
    }, [messages?.length, open, syncScrollToBottomVisibility]);

    const store = async () => {
        if(!text.trim()) return setShowEmoji(true);
        if(!user) return;
        setText("");
        setLoading(true);
        const tempId = "temp-" + Date.now();

        const tempMessage: Message = {
            id: tempId,
            user: user,
            text,
            pending: true
        };

        setMessages(prev => prev ? [...prev, tempMessage] : [tempMessage]);

        try {

            const res = await api(token).post("/chat-global", {
                text
            });

            const newMessage = res.data;

            setMessages(prev => {
                if (prev?.some(msg => msg.id === newMessage.id)) {
                    return prev.filter(msg => msg.id !== tempId);
                }

                return prev?.map(msg =>
                    msg.id === tempId ? { ...newMessage, pending: false } : msg
                ) || null;
            });

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadMessages();
    }, []);

    // Real-time messages + presence (online users) via Reverb presence channel,
    // replacing the old 1s message poll and join/leave/online REST calls.
    useEffect(() => {
        if(!token) return;

        const echo = createEcho(token);
        const channel = echo.join("chat-global");

        channel
            .here((users: unknown[]) => setTotalOnline(users.length))
            .joining(() => setTotalOnline(prev => prev + 1))
            .leaving(() => setTotalOnline(prev => Math.max(0, prev - 1)))
            .listen(".GlobalMessageSent", (message: Message) => {
                setMessages(prev => {
                    if (prev?.some(m => m.id === message.id)) return prev;

                    const withoutOwnPending = prev?.filter(
                        m => !(m.pending && m.user?.id === message.user?.id && m.text === message.text)
                    ) ?? [];

                    return [...withoutOwnPending, message];
                });
            })
            .listen(".GlobalMessageDeleted", ({ id }: { id: string }) => {
                setMessages(prev => prev?.filter(m => String(m.id) !== String(id)) ?? null);
            });

        return () => {
            echo.leave("chat-global");
            echo.disconnect();
        };
    }, [token]);

  return (
    <>
        {(!open && !hideChatGlobal) && (
            <button
            className={`chat-open-button ${open ? "open" : ""} ${nativeKeyboardHeight && nativeKeyboardHeight > 20 ? "chat-open-button-navigation-large" : ""}`}
            onClick={() => setOpen(true)}
            >
            💬 <span className="none-cel">Chat</span>
            </button>
        )}
        <div className={`container-fluid chat-container p-0 ${open && !hideChatGlobal ? "open" : ""}`}>

        <div className="chat-global-content">
                    {/* Header Banner */}
                <header className="chat-banner d-flex align-items-center justify-content-center text-white text-center">
                    
                </header>

                {/* Chat Header */}
                <section className="chat-header d-flex justify-content-between align-items-center px-4 py-3">
                    <div>
                    <h3 className="mb-0">Chat global</h3>
                    <small className="text-light opacity-75">
                        👤 usuários no chat: {totalOnline <= 0 ? 1 : totalOnline}
                    </small>
                    </div>

                    <div className="d-flex gap-3 fs-4 text-light">
                    {/* <span>≡</span> */}
                    <span className="cursor-pointer user-select-none"  onClick={() => setOpen(false)}>✕</span>
                    </div>
                </section>

                {/* Chat Messages */}
                <main className="chat-messages px-3" ref={chatRef} onScroll={syncScrollToBottomVisibility}>
                    <div ref={messagesContentRef}>
                    {messages?.map((msg) => (
                        <div key={msg.id} className={`chat-message d-flex mb-4 ${msg.pending ? "message-pending" : ""}`}>
                            <img src={getImagePathBucketPacoca(msg.user?.img_account, "/img/img-account.png")} className="user-select-none avatar me-2"  style={{ cursor: "pointer" }} onClick={() => navigate(`/@${msg.user.user_name}`)} onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }}/>

                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div className="username" style={{ cursor: "pointer" }} onClick={() => navigate(`/@${msg.user.user_name}`)}>
                                    @{msg.user?.user_name}{" "}
                                    <ImgVerified classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" user={msg?.user} />
                                </div>

                                <div className="message-text-global" dangerouslySetInnerHTML={{ __html: clearText(msg.text) }}/>
                            </div>

                            <PermissionCheck permission="delete_post" id_owner={msg.user?.id}>
                                <button
                                    className="chat-global-delete-btn"
                                    title="Apagar mensagem"
                                    onClick={async () => {
                                        setMessages(prev => prev?.filter(m => m.id !== msg.id) ?? null);
                                        try {
                                            await api(token).delete(`/chat-global/${msg.id}`);
                                        } catch {
                                            loadMessages();
                                        }
                                    }}
                                >
                                    <Trash2 size={14} />
                                </button>
                            </PermissionCheck>
                        </div>
                    ))}
                    </div>
                </main>

                {/* Input */}
                <footer className="chat-input" style={{ paddingBottom: bottomPadding }}>
                    {showScrollToBottom && (
                        <button
                            className="chat-global-scroll-to-bottom"
                            type="button"
                            aria-label="Ir para o fim da conversa"
                            onClick={() => scrollToBottom()}
                        >
                            <ChevronsDown size={20} />
                        </button>
                    )}
                    <div className="input-group" style={{ position: "relative" }}>

                    {showMentions && (
                        <div className="chat-global-mention-dropdown">
                            {loadingMentions && (
                                <div className="chat-global-mention-loading">Buscando...</div>
                            )}
                            {!loadingMentions && mentionSuggestions.length === 0 && (
                                <div className="chat-global-mention-loading">Nenhum usuário encontrado</div>
                            )}
                            {mentionSuggestions.map((u: any) => (
                                <button
                                    key={u.id}
                                    type="button"
                                    className="chat-global-mention-item"
                                    onMouseDown={(e) => { e.preventDefault(); handleSelectMention(u.user_name); }}
                                >
                                    <img
                                        src={getImagePathBucketPacoca(u.img_account, "/img/img-account.png")}
                                        onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }}
                                        className="chat-global-mention-avatar"
                                        alt=""
                                    />
                                    <span className="chat-global-mention-name">@{u.user_name}</span>
                                    {u.name && <span className="chat-global-mention-display">{u.name}</span>}
                                </button>
                            ))}
                        </div>
                    )}

                    <input
                        ref={inputRef}
                        onChange={(e) => handleTextChange(e.target.value)}
                        value={text}
                        onKeyDown={(e) => {
                            if(e.key === "Enter"){
                                store();
                            }
                        }}
                        type="text"
                        className="form-control message-input"
                        placeholder="Mensagem"
                    />

                    <EmojiPickerNative
                        show={showEmoji} 
                        setShow={setShowEmoji} 
                        onSelect={(emoji) => { 
                            setText(prev => prev + emoji);
                            setShowEmoji(false);
                        }}
                        bottom={"10px"}
                    />
                    <button onClick={store} disabled={!!text.trim().length && loading} className="btn emoji-btn">
                        {text.trim().length ? (
                            <>➤</>
                        ) : (
                           <Smile/>
                        )}
                    </button>
                    </div>
                </footer>
        </div>

        </div>
    </>
  );
};

export default ChatGlobal;